var SCM = SCM || {};

(function (ns, $) {

    // init tab
    ns.initMyAccount = function () {
        var $myAcctTabsInnerWrap = $('.myaccount-tabs-inner-wrap'),
            $mobileNavIcon = $('.mobile-nav-icon'),
            $resizeTimer;

        // Scroll
        $(window).on('scroll', function () {
            clearTimeout($resizeTimer);
            $resizeTimer = setTimeout(function () {
                $myAcctTabsInnerWrap.removeAttr('style'); // reset mobile page nav
            }, 50); // in milliseconds
        });

        // Resize
        $(window).on('resize', function () {
            clearTimeout($resizeTimer);
            $resizeTimer = setTimeout(function () {
                $myAcctTabsInnerWrap.removeAttr('style'); // reset mobile page nav
            }, 50); // in milliseconds
        });

        // highlight active tab
        var activeTabUrl = location.pathname;
        // the pathname should be like: /my-account/{tabName}/{mode}, while the mode is optional and should be ignored when highlighting the main tab
        var modeIndex = activeTabUrl.indexOf('/', '/my-account/'.length);
        if (modeIndex > 0) {
            activeTabUrl = activeTabUrl.substring(0, modeIndex);
        }

        var $activeTab = $('.myaccount-tabs-inner-wrap').find('li').has('a[href="' + activeTabUrl + '"]');
        $activeTab.addClass('is-active');

        //edit personal details
        $(document).on('click', '#myaccount-tabs-content #updatePersonalDetailsBtn', function () {
            var $formContainer = $('#myaccount-tabs-content');

            $formContainer.find('.success-message').html('').hide();
            $formContainer.find('.error-message').html('').hide();

            var title = $formContainer.find('#Title').val();
            var firstName = $formContainer.find('#FirstName').val();
            var lastName = $formContainer.find('#LastName').val();
            var phone = $formContainer.find('#Phone').val();
            var country = $formContainer.find('#CountryList').val();

            var brackets = /[<>]/;
            if (brackets.test(title) || brackets.test(firstName) || brackets.test(lastName) || brackets.test(phone)) {
                var bracketErr = $formContainer.find('#err-message-angle-brackets').html();
                $formContainer.find('.error-message').html(bracketErr).show();
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);

                return;
            }

            $.post('/MyAccount/UpdateAccount',
                { title: title, firstName: firstName, lastName: lastName, phone: phone, country: country },
                function (data) {
                    if (data.Success) {
                        $('#header-account-info-user-fullname').html(firstName + ' ' + lastName);
                        $formContainer.find('.success-message').html(data.Html).show();
                    }
                    else {
                        $formContainer.find('.error-message').html(data.Html).show();
                        $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                    }
                });
        });

        //change password
        var initialErrorMessage = $('#change-password').find('.error-message').html();
        $(document).on('click', '#changePasswordBtn', function () {
            var $formContainer = $('#change-password');

            var $successMsg = $formContainer.find('.success-message');
            $successMsg.hide();

            var $errMsg = $formContainer.find('.error-message');
            $errMsg.html(initialErrorMessage).hide();

            var errors = {};
            var currentPassword = $formContainer.find('#currentPassword').val();
            var noInput = false;
            if (currentPassword === '') {
                errors['currentPassword'] = $('label[for=currentPassword]').text().replace('*', '');
                noInput = true;
            }
            var newPassword = $formContainer.find('#newPassword').val();
            if (newPassword === '') {
                errors['newPassword'] = $('label[for=newPassword]').text().replace('*', '');
                noInput = true;
            }
            var confirmNewPassword = $formContainer.find('#confirmNewPassword').val();
            if (confirmNewPassword === '') {
                errors['confirmNewPassword'] = $('label[for=confirmNewPassword]').text().replace('*', '');
                noInput = true;
            }
            if (noInput) {
                for (var key in errors) {
                    $errMsg.append('<p> * ' + errors[key] + '</p>').show();
                }
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                return;
            }
            $errMsg.html('');

            $.post('/MyAccount/ChangePassword',
                { currentPassword: currentPassword, newPassword: newPassword, confirmNewPassword: confirmNewPassword },
                function (result) {
                    if (result[0] == '1') {
                        $successMsg.show();

                        // redo a login to refresh un/pw cookie. 
                        $.post('/LOGIN', { user: result[1], pass: newPassword, dest: '/HTTPHandlers/SAMs/LoginHandler.ashx' })
                            .done(function (result) {
                                if (result !== '1') { // just in case
                                    location.href = '/sign-in';
                                }
                            });

                    } else {

                        $errMsg.html(result[1]).show();
                        $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                    }
                });
        });

        //change email address
        $(document).on('click', '#changeEmailBtn', function () {
            var $formContainer = $('#change-email-address');
            var $successMsg = $formContainer.find('.success-message');
            var $errMsg = $formContainer.find('.error-message');
            var newEmailAddress = $formContainer.find('#newEmailAddress').val();
            var confirmNewEmailAddress = $formContainer.find('#confirmNewEmailAddress').val();
            var password = $formContainer.find('#currentPassword').val();
            var errors = {};
            var noInput = false;

            $errMsg.html('');

            //Check that all required fields have input
            if (newEmailAddress === '') {
                errors['newEmailAddress'] = $('label[for=newEmailAddress]').text().replace('*', '');
                noInput = true;
            }
            if (confirmNewEmailAddress === '') {
                errors['confirmNewEmailAddress'] = $('label[for=confirmNewEmailAddress]').text().replace('*', '');
                noInput = true;
            }
            if (password === '') {
                errors['password'] = $('label[for=currentPassword]').text().replace('*', '');
                noInput = true;
            }
            if (noInput) {
                $errMsg.append('Please complete the following required fields:');

                for (var key in errors) {
                    $errMsg.append('<p> * ' + errors[key] + '</p>');
                }

                $errMsg.show();
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                return;
            }

            $.post('/UserDashboard/RequestEmailAddressChange',
                { newEmailAddress: newEmailAddress, confirmNewEmailAddress: confirmNewEmailAddress, password: password },
                function (data) {
                    if (data != null) {
                        if (data.Success) {
                            $formContainer.children('.change-email-address-form').hide();
                            $successMsg.show();
                        }
                        else {
                            var i = 0;
                            var len = data.Messages.length;
                            for (i; i < len; i++) {
                                $errMsg.append('<p> * ' + data.Messages[i] + '</p>');
                            }
                            $errMsg.show();
                            $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                        }
                    }
                });
        });
    };

    function _bindPasswordCheckPopupToggle($form, $passwordCheckWrap) {
        $form.on('click', '.password-input-icon, .password-confirm-icon', function (e) {
            e.stopPropagation();
            $passwordCheckWrap.show();
        });

        $(document).on('click', function () {
            $passwordCheckWrap.hide();
        });
    }

    ns.initTestPassword = function () {
        var $form = $('.register-form-wrap, .editable-userprofile-info');

        var $minSize = 10,
            $checkForCase = /[A-Z]/,
            $checkForNumber = /[0-9]/,
            $existingPasswordInput = '',
            $iconCase = $form.find('.icon-case'),
            $iconConfirm = $form.find('.password-confirm-icon'),
            $iconInput = $form.find('.password-input-icon'),
            $iconLength = $form.find('.icon-length'),
            $iconNumber = $form.find('.icon-number'),
            $passwordCheckWrap = $form.find('.password-check-wrap'),
            $validPassword = false;

        $form.on('keyup', '#Password', function () {
            var $currentInputEntry = $(this).val();

            $existingPasswordInput = $currentInputEntry; // for comparison with confirmation input

            // only show requirements if the password doesn't meet them
            $validPassword ? $passwordCheckWrap.hide() : $passwordCheckWrap.show();

            // test the number of characters
            $currentInputEntry.length >= $minSize ? SCM.MyAccount.showValidPasswordCriteria($iconLength) : SCM.MyAccount.showInvalidPasswordCriteria($iconLength);

            // test for presence of an uppercase character
            $checkForCase.test($currentInputEntry) ? SCM.MyAccount.showValidPasswordCriteria($iconCase) : SCM.MyAccount.showInvalidPasswordCriteria($iconCase);

            // test for presence of a number
            $checkForNumber.test($currentInputEntry) ? SCM.MyAccount.showValidPasswordCriteria($iconNumber) : SCM.MyAccount.showInvalidPasswordCriteria($iconNumber);

            // if all criteria are met, hide the requirements
            if ($iconLength.hasClass('green') && $iconCase.hasClass('green') && $iconNumber.hasClass('green')) {
                $validPassword = true;
                $passwordCheckWrap.fadeOut(1500);
                $iconInput.hide();

            // in case current input actually matches the confirm
            if ($currentInputEntry === $form.find('#ConfirmPassword').val()) {
                $iconConfirm.hide();
                $form.find('#registerBtn').addClass('btn-green');
                $form.find('.register-button-overlay').hide();
            }
            }
            else {
                $validPassword = false;
                $passwordCheckWrap.show();
                $iconInput.show();
            }

            if ($currentInputEntry === '' || $currentInputEntry === null) {
                // hide if input is empty
                $passwordCheckWrap.hide();
                $iconInput.hide();
            }
        });

        $form.on('keyup', '#ConfirmPassword', function () {
            var $currentConfirmEntry = $(this).val();

            if ($existingPasswordInput === $currentConfirmEntry) {
                // passwords match: hide the icon
                $iconConfirm.hide();
                if ($validPassword) {
                    // passwords match & are valid: uncover the button
                    $form.find('#registerBtn').addClass('btn-green');
                    $form.find('.register-button-overlay').hide();
                }
            } else if ($currentConfirmEntry === '' || $currentConfirmEntry === null) {
                // empty input: hide the icon, but cover the button
                $iconConfirm.hide();
            } else {
                // input doesn't match: show the icon & cover the button
                $iconConfirm.show();
            }
        });

        _bindPasswordCheckPopupToggle($form, $passwordCheckWrap);
    };

    ns.initTestPasswordWithExtendedRequirements = function () {
        var $form = $('.register-form-wrap, .editable-userprofile-info');

        var $minSize = 12,
            $checkForCase = /[A-Z]/,
            $checkForLowerCase = /[a-z]/,
            $checkForNumber = /[0-9]/,
            $checkForSpecialCharacter = /[^a-zA-Z0-9]/,
            $minPasswordConditionsPassed = 3,
            $existingPasswordInput = '',
            $iconCase = $form.find('.icon-case'),
            $iconLowerCase = $form.find('.icon-lower-case'),
            $iconConfirm = $form.find('.password-confirm-icon'),
            $iconInput = $form.find('.password-input-icon'),
            $iconLength = $form.find('.icon-length'),
            $iconNumber = $form.find('.icon-number'),
            $iconSpecialCharacter = $form.find('.icon-special-character'),
            $passwordCheckWrap = $form.find('.password-check-wrap'),
            $validPassword = false;

        $form.on('keyup', '#Password', function () {
            var $currentInputEntry = $(this).val();
            var $passwordConditionsPassed = 0;
            $existingPasswordInput = $currentInputEntry; // for comparison with confirmation input

            // only show requirements if the password doesn't meet them
            $validPassword ? $passwordCheckWrap.hide() : $passwordCheckWrap.show();

            // test the number of characters
            $currentInputEntry.length >= $minSize ? SCM.MyAccount.showValidPasswordCriteria($iconLength) : SCM.MyAccount.showInvalidPasswordCriteria($iconLength);

            // test for presence of an uppercase character
            var upperCasePassed = $checkForCase.test($currentInputEntry);
            $passwordConditionsPassed += upperCasePassed ? 1 : 0;
            upperCasePassed ? SCM.MyAccount.showValidPasswordCriteria($iconCase) : SCM.MyAccount.showInvalidPasswordCriteria($iconCase);

            // test for presence of an lowercase character
            var lowerCasePassed = $checkForLowerCase.test($currentInputEntry);
            $passwordConditionsPassed += lowerCasePassed ? 1 : 0;
            lowerCasePassed ? SCM.MyAccount.showValidPasswordCriteria($iconLowerCase) : SCM.MyAccount.showInvalidPasswordCriteria($iconLowerCase);

            // test for presence of a number
            var numberCasePassed = $checkForNumber.test($currentInputEntry);
            $passwordConditionsPassed += numberCasePassed ? 1 : 0;
            numberCasePassed ? SCM.MyAccount.showValidPasswordCriteria($iconNumber) : SCM.MyAccount.showInvalidPasswordCriteria($iconNumber);

            // test for presence of an special character
            var specialCharacterCasePassed = $checkForSpecialCharacter.test($currentInputEntry);
            $passwordConditionsPassed += specialCharacterCasePassed ? 1 : 0;
            specialCharacterCasePassed ? SCM.MyAccount.showValidPasswordCriteria($iconSpecialCharacter) : SCM.MyAccount.showInvalidPasswordCriteria($iconSpecialCharacter);

            // if all criteria are met, hide the requirements
            if ($currentInputEntry.length >= $minSize && $passwordConditionsPassed >= $minPasswordConditionsPassed) {
                $validPassword = true;
                $passwordCheckWrap.fadeOut(1500);
                $iconInput.hide();

                // in case current input actually matches the confirm
                if ($currentInputEntry === $form.find('#ConfirmPassword').val()) {
                    $iconConfirm.hide();
                    $form.find('#registerBtn').addClass('btn-green');
                    $form.find('.register-button-overlay').hide();
                }
            }
            else {
                $validPassword = false;
                $passwordCheckWrap.show();
                $iconInput.show();
            }

            if ($currentInputEntry === '' || $currentInputEntry === null) {
                // hide if input is empty
                $passwordCheckWrap.hide();
                $iconInput.hide();
            }
        });

        $form.on('keyup', '#ConfirmPassword', function () {
            var $currentConfirmEntry = $(this).val();

            if ($existingPasswordInput === $currentConfirmEntry) {
                // passwords match: hide the icon
                $iconConfirm.hide();
                if ($validPassword) {
                    // passwords match & are valid: uncover the button
                    $form.find('#registerBtn').addClass('btn-green');
                    $form.find('.register-button-overlay').hide();
                }
            } else if ($currentConfirmEntry === '' || $currentConfirmEntry === null) {
                // empty input: hide the icon, but cover the button
                $iconConfirm.hide();
            } else {
                // input doesn't match: show the icon & cover the button
                $iconConfirm.show();
            }
        });

        _bindPasswordCheckPopupToggle($form, $passwordCheckWrap);
    }
    // for VALID password criteria
    ns.showValidPasswordCriteria = function (icon) {
        icon.removeClass('icon-general-close red').addClass('icon-general-check green').show();
        icon.siblings('.password-check-label').addClass('fade').show();
    };

    // for HIDE password criteria
    ns.hideValidPasswordCriteria = function (icon) {
        icon.hide();
        icon.siblings('.password-check-label').hide();
    };

    // for INVALID password criteria
    ns.showInvalidPasswordCriteria = function (icon) {
        icon.removeClass('icon-general-check green').addClass('icon-general-close red').show();
        icon.siblings('.password-check-label').removeClass('fade').show();
    };

    ns.initForgotPassword = function () {
        var initialForgotPasswordErrorMessage = $('#forgot-password').find('.error-message').html();

        $('#forgotPasswordBtn').on('click', function () {
            var $button = $(this);
            var $formContainer = $('#forgot-password');

            if ($button.attr('disabled') === 'disabled' || $button.hasClass('disabled')) {
                return false;
            }

            var $successMsg = $formContainer.find('.success-message');
            var $errMsg = $formContainer.find('.error-message');
            let validationErrorDetected = false;

            const $errorMessageContactEmail = $formContainer.find('.js-error-message-contact-email');
            const $errorMessageCaptcha = $formContainer.find('.js-error-message-captcha');
            const validateEmailFormat = $errorMessageContactEmail.data('validateEmailFormat')?.toLowerCase() !== 'false';

            $successMsg.html('').hide();
            $errMsg.html(initialForgotPasswordErrorMessage).hide();

            $errorMessageContactEmail.addClass('hide');
            $errorMessageCaptcha.addClass('hide');
            $('#contactEmail').removeAttr('aria-invalid');

            var email = $formContainer.find('#contactEmail').val();
            var hfCaptchaEnableVal = $formContainer.find('#hfCaptchaEnabledForForgotPassword').val();

            var postData = { email: email };
            if (hfCaptchaEnableVal === '1') {
                postData.captchaChallenge = 'not empty';
                postData.captchaResponse = SCM.Captcha.GetCaptchaResponse($formContainer);
                postData.captchaInstanceName =  SCM.Captcha.GetCaptchaInfo().ReCaptchaWidgetControlId;
            }

            // validate user enter email address and captcha response if enabled
            if (postData.email.length === 0) {
                validationErrorDetected = true;
                $errorMessageContactEmail.html($errorMessageContactEmail.data('requiredMessage')).removeClass('hide');
                $('#contactEmail').attr('aria-invalid', 'true');
            }
            else if (validateEmailFormat && !SCM.JSUtility.isValidEmail(postData.email)) {
                validationErrorDetected = true;
                $errorMessageContactEmail.html($errorMessageContactEmail.data('formatMessage')).removeClass('hide');
                $('#contactEmail').attr('aria-invalid', 'true');
            }

            if (hfCaptchaEnableVal === '1' && postData.captchaResponse.length === 0) {
                validationErrorDetected = true;
                $errorMessageCaptcha.removeClass('hide');
            }
            if (!validationErrorDetected) {
                $button.prop('disabled', true).addClass('disabled');

                $.post('/UserDashboard/ForgotPassword',
                    postData,
                    function (err) {
                        if (err == null || err == '') {
                            var confirmMsg = $formContainer.find('.success-message-template').html().replace('{0}', email);
                            $('.js-hide-after-submit').hide();
                            $successMsg.html(confirmMsg).show();
                            $formContainer.find('.js-forgot-password-announcement').html(confirmMsg);
                        }
                        else {
                            $errMsg.html(err).show();
                            $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                            $button.prop('disabled', false).removeClass('disabled');
                        }
                        // reload captcha if enabled
                        if (hfCaptchaEnableVal === '1') {
                            SCM.Captcha.ResetCaptcha($formContainer);
                        }
                    },
                    'html');
            }
        });
    };

    ns.initSendAccountActivationEmail = function () {
        $('#sendAccountVerificationEmailBtn').on('click', function () {
            var $formContainer = $('#send-email-verification');
            var $successMsg = $formContainer.find('.success-message');
            var $errMsg = $formContainer.find('.js-error-message');
            var defaultMessage = $errMsg.data('defaultmessage');
            var actionTypeId = $(this).data('actionTypeId');
            var email = $formContainer.find('#contactEmail').val();
            if (email.length === 0) {
                var validationErr = defaultMessage + '<p> * ' + $('label[for=contactEmail]').text().replace('*', '') + '</p>';
                $errMsg.html(validationErr);
                $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                return;
            }

            SCM.Ajax.post('/AccountActionVerification/SendAccountActionEmail', { email: email, actionTypeId: actionTypeId })
                .expectJson()
                .then(function (result) {
                    if (result.Success) {
                        var confirmMsg = $formContainer.find('.success-message-template').html().replace('{0}', email);
                        $('.js-hide-after-submit').addClass('hide');
                        $successMsg.html(confirmMsg).removeClass('hide');
                        $errMsg.addClass('hide');
                    } else {
                        $errMsg.html(result.Messages[0]).removeClass('hide');
                        $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                    }
                })
                .catch(console.error);
        });
    };

    ns.initResetPassword = function () {
        $('#changePasswordBtn').on('click', function () {
            var $button = $(this);
            var $formContainer = $('#change-password');

            if ($button.attr('disabled') === 'disabled' || $button.hasClass('disabled')) {
                return false;
            }

            var $successMsg = $formContainer.find('.success-message');
            var $errMsg = $formContainer.find('.error-message');
            var $errMsgDefault = $formContainer.find('.default');

            var token = SCM.JSUtility.getSearchParamByName('t');
            var newPassword = $formContainer.find('#newPassword').val();
            var confirmNewPassword = $formContainer.find('#confirmNewPassword').val();

            $button.prop('disabled', true).addClass('disabled');

            $.post('/UserDashboard/ResetPassword',
                { token: token, newPassword: newPassword, confirmNewPassword: confirmNewPassword },
                function (err) {
                    if (err == null || err == '') {
                        var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');

                        $successMsg.show();
                        $errMsg.hide();
                        $('.js-hide-after-submit').hide();

                        setTimeout(function() {
                            if (returnUrl) {
                                window.location.assign(returnUrl);
                            }
                        }, 4000);
                    }
                    else {
                        $errMsgDefault.removeClass('default');
                        $successMsg.hide();
                        $errMsg.html(err).show();
                        $('html, body').animate({ scrollTop: $formContainer.offset().top }, 10);
                        $button.prop('disabled', false).removeClass('disabled');
                    }
                },
                'html');
        });
    };

    ns.countSubjectChoices = function () {
        $('#communication-preferences-subject-choices').find('.topics-selected-wrap').each(function () {
            var $totelOptions = $(this).closest('li').find('input[type=checkbox]');
            var $selectedOptions = $totelOptions.filter(':checked');

            $(this).find('.totalCount').html($totelOptions.length);
            $(this).find('.checkedTotal').html($selectedOptions.length);
            $(this).show();
        });
    };

    ns.changeUserTypeSubjects = function (reset) {
        var $container = $('#communication-preferences');
        $('#userTypeSubjectHeader').hide();
        var classificationId = $container.find('#userTypes').val();
        if (classificationId === '3') { // Show this heading only for Librarian 
            $('#userTypeSubjectHeader').show();
        }

        $container.find('ul#userTypeSubjects > li').each(function () {
            var $checkbox = $(this).find('input[type=checkbox]');
            //selected subject
            if ($(this).attr('data-classification-id') === classificationId) {
                $(this).show();

                // reset to original choice
                if (reset) {
                    $checkbox.prop('checked', $checkbox.data('checked'));
                }
            }
            else {
                $(this).hide();

                // uncheck all
                if (reset) {
                    $checkbox.prop('checked', false);
                }
            }
        });
    };

})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);


/******************************************************************
Copied from MyAccount.aspx, need to be revised
*******************************************************************/
$(document).ready(function () {

    // show that myaccounts is doing something
    $(document).on('click', '.myaccount-tabs-inner-wrap div', function () {
        $('.tabbed-content-overlay').show();
    });

    //hide the overlay when the new tab is loaded
    $('#myaccount-tabs-content').on('DOMSubtreeModified', function () {
        $('.tabbed-content-overlay').hide();
    });

    $('#institutionalLogoURL').keyup(function () {
        $('.logoPreview').attr('src', $(this).val());
        $('.logoPreview').error(function () {
            $(this).attr('src', '/Images/grey.gif');
        });
    });
});